import getAccessToken from './getAccessToken';

export default function hasAccessToken(): Promise<boolean>
{
    return getAccessToken()
        .then(
            accessToken =>
                Promise.resolve(accessToken !== undefined));
}
